import { MEANINGFUL_DELTA, MUTED_CHANGE_SENTENCE } from '../../constants';

// Passed to HeatmapV2 to opt its cells into the trend renderer — the same way
// BenchmarkHeatmap opts into the benchmark one.
export const TREND_STYLE = {
    meaningfulDelta: MEANINGFUL_DELTA,
};

export const HEADER_TEXT = {
    title: 'Heatmap',
    description: 'Change in mean score from the earlier to the latest 360 for the compared participants, shaded on a diverging scale centered on zero. Changes below the meaningful-change band are muted.',
    note: `Only leaders with results at both time points are compared. ${MUTED_CHANGE_SENTENCE}`,
};

export const HEATMAP_KEY = {
    shading: 'Change from the earlier to the latest 360 — red = decline, green = improvement',
};
